module.exports = __webpack_public_path__ + "static/media/rodrigo-ardilha.357056d8.jpg";